import { render } from "./resourceItem.vue?vue&type=template&id=5026e2e2&scoped=true"
import script from "./resourceItem.vue?vue&type=script&lang=js"
export * from "./resourceItem.vue?vue&type=script&lang=js"

import "./resourceItem.vue?vue&type=style&index=0&id=5026e2e2&lang=scss&scoped=true"

import exportComponent from "/Users/bill/rongge/code/已售项目/20340305/front/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5026e2e2"]])

export default __exports__